import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Dialog as MaterialDialog, Grid, Portal } from '@material-ui/core';
import { EmptyState, palette } from '@dev/ee-components';
import { TemplatesPreview } from '@dev/ee-modules';
import useMobile from '@/services/hooks/useMobile';
import { ApplicationState } from '@/store';

const Overlay = styled.div`
    background: ${palette.snow[1]};
    height: max-content;

    .MuiContainer-root {
        padding-top: 60px;
    }
    iframe{
        background: unset !important;
    }
`;

const EmptyStateWrapper = styled.div`
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
    margin-top: 27px;
    max-width: 62vw;
    margin: auto;
    #empty-state {
        padding-top: 52px;
        padding-bottom: 52px;
    }
`;

interface PreviewLandingPageProps {
    name: string;
    previewContent: string;
    onClose: () => void;
    open: boolean;
}

export const PreviewLandingPage = (props: PreviewLandingPageProps): JSX.Element => {
    const { t } = useTranslation();
    const { name, previewContent, onClose, open } = props;
    const isMobile = useMobile();
    const browser = useSelector((state: ApplicationState) => state.browser);

    return (
        <Portal>
            <MaterialDialog open={open} fullScreen>
                <Overlay>
                    <Grid container justifyContent="center" style={{ padding: '0px 16px' }}>
                        <Grid item xs={12} sm={12} style={{ maxWidth: 1170, paddingBottom: 16 }}>
                            <TemplatesPreview
                                fullWidthContent
                                open={open}
                                browser={browser}
                                templateHtml={previewContent ?? null}
                                templateName={name ?? ''}
                                isMobile={isMobile}
                                onCloseClick={onClose}
                                emptyComponent={
                                    <EmptyStateWrapper>
                                        <EmptyState text={t('emptystate')} />
                                    </EmptyStateWrapper>
                                }
                            />
                        </Grid>
                    </Grid>
                </Overlay>
            </MaterialDialog>
        </Portal>
    );
}
